"use client"

import * as React from "react"
import {
  LayoutDashboard,
  Calendar,
  Users,
  UserCog,
  TrendingUp,
  Settings,
  HelpCircle,
  Building2,
  Sparkles,
} from "lucide-react"

import { NavMain } from "./NavMain"
import { NavProjects } from "./NavProjects"
import { NavUser } from "./NavUser"
import { TeamSwitcher } from "./TeamSwitcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { useStore } from "@/store/useStore"
import { useAuthContext } from "@/hooks/useAuth"

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  // 認証情報: React Context（単一の真実の源）から取得
  const { user } = useAuthContext()

  // ストア情報: Zustandから取得
  const storeName = useStore((state) => state.settings?.store?.storeName)

  // メインナビゲーション
  const navMain = [
    {
      title: "ダッシュボード",
      url: "/dashboard",
      icon: LayoutDashboard,
      isActive: true,
    },
    {
      title: "予約管理",
      url: "/reservations",
      icon: Calendar,
    },
    {
      title: "顧客管理",
      url: "/customers",
      icon: Users,
      items: [
        { title: "顧客一覧", url: "/customers" },
        { title: "カルテ管理", url: "/customers/records" },
      ],
    },
    {
      title: "スタッフ",
      url: "/staff",
      icon: UserCog,
    },
        {
      title: "売上分析",
      url: "/sales",
      icon: TrendingUp,
    },
    {
      title: "AI分析",
      url: "/ai-analysis",
      icon: Sparkles,
    },
  ]

  // 下部ナビゲーション（設定・ヘルプ）
  const bottomNav = [
    {
      title: "組織設定",
      url: "/organization/settings",
      icon: Building2,
    },
    {
      title: "設定",
      url: "/settings",
      icon: Settings,
    },
    {
      title: "ヘルプ",
      url: "/help",
      icon: HelpCircle,
    },
  ]

  // チーム情報（組織切替用）
  const teams = [
    {
      name: storeName || "SALONHUB",
      logo: Sparkles,
      plan: "Premium",
    },
  ]

  return (
    <Sidebar collapsible="icon" variant="inset" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        <NavProjects items={bottomNav} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
